import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/credential',
    name: 'credential',
    component: () => import('@/views/certificate/credential/Credential.vue'),
    meta: {
      pageTitle: 'Danh sách các loại văn bằng/chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý các loại văn bằng/chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CREDENTIAL,
    },
  },
  {
    path: '/credentialType',
    name: 'credentialType',
    component: () => import('@/views/certificate/credential-type/CredentialType.vue'),
    meta: {
      pageTitle: 'Danh sách các kiểu văn bằng/chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý các kiểu văn bằng/chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CREDENTIAL_TYPE,
    },
  },
  {
    path: '/certificateBlank',
    name: 'certificateBlank',
    component: () => import('@/views/certificate/certificate-blank/CertificateBlank.vue'),
    meta: {
      pageTitle: 'Quản lý kho phôi văn bằng/chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý kho phôi văn bằng/chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CERTIFICATE_BLANK,
    },
  },
  {
    path: '/certificateProcessType',
    name: 'certificateProcessType',
    component: () => import('@/views/certificate/certificate-process-types/CertificateProcessType.vue'),
    meta: {
      pageTitle: 'Quản lý các loại yêu cầu cho văn bằng chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý các loại yêu cầu cho văn bằng/chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CERTIFICATE_PROCESS_TYPE,
    },
  },
  {
    path: '/createCredential',
    name: 'createCredential',
    component: () => import('@/views/certificate/create-credential/CreateCredential.vue'),
    meta: {
      pageTitle: 'Quản lý cấp văn bằng, chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Cấp văn bằng, chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CREATE_CREDENTIAL,
    },
  },
  {
    path: '/credentialStorage',
    name: 'credentialStorage',
    component: () => import('@/views/certificate/credential-storage/CredentialStorage.vue'),
    meta: {
      pageTitle: 'Quản lý kho văn bằng, chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Kho văn bằng, chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CREDENTIAL_STORAGE,
    },
  },
  {
    path: '/credentialProcessRequest',
    name: 'credentialProcessRequest',
    component: () => import('@/views/certificate/credential-process-request/CredentialProcessRequest.vue'),
    meta: {
      pageTitle: 'Quản lý yêu cầu xử lý văn bằng, chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý yêu cầu xử lý văn bằng, chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CREDENTIAL_PROCESS_REQUEST,
    },
  },
  {
    path: '/certificateImplements',
    name: 'certificateImplements',
    component: () => import('@/views/certificate/cerificate-implement/CertificateImplement.vue'),
    meta: {
      pageTitle: 'Quản lý khung thời gian triển khai văn bằng, chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý khung thời gian triển khai văn bằng, chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CERTIFICATE_IMPLEMENT,
    },
  },
  {
    path: '/certificateBlankStatus',
    name: 'certificateBlankStatus',
    component: () => import('@/views/certificate/certificate-blank-status/CertificateBlankStatus.vue'),
    meta: {
      pageTitle: 'Quản lý danh mục trạng thái phôi',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Quản lý danh mục trạng thái phôi',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CERTIFICATE_BLANK_STATUS,
    },
  },
  {
    path: '/credentialCopyStorage',
    name: 'credentialCopyStorage',
    component: () => import('@/views/certificate/credential-copy-storage/CredentialCopyStorage.vue'),
    meta: {
      pageTitle: 'Quản lý kho cấp bản sao văn bằng, chứng chỉ',
      breadcrumb: [
        {
          text: 'Quản lý văn bằng/chứng chỉ',
          active: false,
        },
        {
          text: 'Kho cấp bản sao văn bằng, chứng chỉ',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.CREDENTIAL_COPY_STORAGE,
    },
  },
]
